import React from 'react';
import Button from '../Button/Button.es.js';
import '../../utils/assertions.es.js';
import { maestroComponent } from '../../utils/componentHelpers.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { useBreakpoint } from '../../hooks/useBreakpoint/useBreakpoint.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import 'react-beautiful-dnd';
import 'nanoid/non-secure';
import '../../assets/icons/custom/CheckIcon.es.js';
import '../../assets/icons/generated/filled/AndroidFilled.es.js';
import '../../assets/icons/generated/filled/AppleFilled.es.js';
import '../../assets/icons/generated/filled/ArrowForwardFilled.es.js';
import '../../assets/icons/generated/filled/CameraAddFilled.es.js';
import '../../assets/icons/generated/filled/CameraFilled.es.js';
import '../../assets/icons/generated/filled/CdPauseFilled.es.js';
import CheckCircleFilled from '../../assets/icons/generated/filled/CheckCircleFilled.es.js';
import '../../assets/icons/generated/filled/CommentsFilled.es.js';
import '../../assets/icons/generated/filled/CommentsTextFilled.es.js';
import '../../assets/icons/generated/filled/CreditCardFilled.es.js';
import '../../assets/icons/generated/filled/CrownFilled.es.js';
import '../../assets/icons/generated/filled/DownloadCircleFilled.es.js';
import '../../assets/icons/generated/filled/FacebookFilled.es.js';
import '../../assets/icons/generated/filled/FolderFilled.es.js';
import '../../assets/icons/generated/filled/HeartFilled.es.js';
import '../../assets/icons/generated/filled/HelpFilled.es.js';
import InfoFilled from '../../assets/icons/generated/filled/InfoFilled.es.js';
import '../../assets/icons/generated/filled/InstagramFilled.es.js';
import '../../assets/icons/generated/filled/KebabFilled.es.js';
import '../../assets/icons/generated/filled/LightningFilled.es.js';
import '../../assets/icons/generated/filled/LinkFilled.es.js';
import '../../assets/icons/generated/filled/LockFilled.es.js';
import '../../assets/icons/generated/filled/MasterFilled.es.js';
import '../../assets/icons/generated/filled/MeatballsFilled.es.js';
import '../../assets/icons/generated/filled/PauseFilled.es.js';
import '../../assets/icons/generated/filled/PlayFilled.es.js';
import '../../assets/icons/generated/filled/RecordFilled.es.js';
import '../../assets/icons/generated/filled/ReleasesFilled.es.js';
import '../../assets/icons/generated/filled/RemoveFilled.es.js';
import '../../assets/icons/generated/filled/ReplyFilled.es.js';
import '../../assets/icons/generated/filled/SpotifyFilled.es.js';
import '../../assets/icons/generated/filled/StarFilled.es.js';
import '../../assets/icons/generated/filled/StarHalfFilled.es.js';
import '../../assets/icons/generated/filled/StopFilled.es.js';
import '../../assets/icons/generated/filled/TwitterFilled.es.js';
import '../../assets/icons/generated/filled/UsersFilled.es.js';
import '../../assets/icons/generated/filled/VolumeFilled.es.js';
import '../../assets/icons/generated/filled/VolumeMuteFilled.es.js';
import WarningFilled from '../../assets/icons/generated/filled/WarningFilled.es.js';
import '../../assets/icons/generated/filled/WindowsFilled.es.js';
import '../../assets/icons/generated/filled/YoutubeFilled.es.js';
import '../../assets/icons/generated/outlined/CalendarOutlined.es.js';
import '../../assets/icons/generated/outlined/AddFileOutlined.es.js';
import '../../assets/icons/generated/outlined/AddOutlined.es.js';
import '../../assets/icons/generated/outlined/AddReleaseOutlined.es.js';
import '../../assets/icons/generated/outlined/AddToCollectionOutlined.es.js';
import '../../assets/icons/generated/outlined/AddSongOutlined.es.js';
import '../../assets/icons/generated/outlined/AlbumOutlined.es.js';
import '../../assets/icons/generated/outlined/ArchiveOutlined.es.js';
import '../../assets/icons/generated/outlined/ArrowBackOutlined.es.js';
import '../../assets/icons/generated/outlined/ArrowForwardOutlined.es.js';
import '../../assets/icons/generated/outlined/ArrowDownOutlined.es.js';
import '../../assets/icons/generated/outlined/ArrowUpOutlined.es.js';
import '../../assets/icons/generated/outlined/AttachmentOutlined.es.js';
import '../../assets/icons/generated/outlined/BassOutlined.es.js';
import '../../assets/icons/generated/outlined/BellOutlinedOff.es.js';
import '../../assets/icons/generated/outlined/BellOutlined.es.js';
import '../../assets/icons/generated/outlined/BentoOutlined.es.js';
import '../../assets/icons/generated/outlined/CameraOffOutlined.es.js';
import '../../assets/icons/generated/outlined/CameraOutlined.es.js';
import '../../assets/icons/generated/outlined/CancelOutlined.es.js';
import '../../assets/icons/generated/outlined/CaretDownOutlined.es.js';
import '../../assets/icons/generated/outlined/CaretLeftOutlined.es.js';
import '../../assets/icons/generated/outlined/CaretRightOutlined.es.js';
import '../../assets/icons/generated/outlined/CaretUpOutlined.es.js';
import '../../assets/icons/generated/outlined/CdArrowOutlined.es.js';
import '../../assets/icons/generated/outlined/CdTimerOutlined.es.js';
import '../../assets/icons/generated/outlined/CheckOutlined.es.js';
import '../../assets/icons/generated/outlined/CheckCircleOutlined.es.js';
import '../../assets/icons/generated/outlined/ClockOutlined.es.js';
import '../../assets/icons/generated/outlined/CloseOutlined.es.js';
import '../../assets/icons/generated/outlined/CloudUploadOutlined.es.js';
import '../../assets/icons/generated/outlined/CogOutlined.es.js';
import '../../assets/icons/generated/outlined/CommentMusicNoteOutlined.es.js';
import '../../assets/icons/generated/outlined/ComputerDesktopOutlined.es.js';
import '../../assets/icons/generated/outlined/CopyOutlined.es.js';
import '../../assets/icons/generated/outlined/CouponOutlined.es.js';
import '../../assets/icons/generated/outlined/CrownOutlined.es.js';
import '../../assets/icons/generated/outlined/DeliveryOutlined.es.js';
import '../../assets/icons/generated/outlined/DiskOutlined.es.js';
import '../../assets/icons/generated/outlined/DownloadOutlined.es.js';
import '../../assets/icons/generated/outlined/DragOutlined.es.js';
import '../../assets/icons/generated/outlined/DrumsOutlined.es.js';
import '../../assets/icons/generated/outlined/EditOutlined.es.js';
import '../../assets/icons/generated/outlined/EmojiOutlined.es.js';
import '../../assets/icons/generated/outlined/ExpandOutlined.es.js';
import '../../assets/icons/generated/outlined/ExternalLinkOutlined.es.js';
import '../../assets/icons/generated/outlined/FileOutlined.es.js';
import '../../assets/icons/generated/outlined/FilterOutlined.es.js';
import '../../assets/icons/generated/outlined/FiltersOutlined.es.js';
import '../../assets/icons/generated/outlined/FlagOutlined.es.js';
import '../../assets/icons/generated/outlined/FolderMusic.es.js';
import '../../assets/icons/generated/outlined/FolderOutlined.es.js';
import '../../assets/icons/generated/outlined/GiftOutlined.es.js';
import '../../assets/icons/generated/outlined/GlobeOutlined.es.js';
import '../../assets/icons/generated/outlined/GrandPianoOutlined.es.js';
import '../../assets/icons/generated/outlined/GridOutlined.es.js';
import '../../assets/icons/generated/outlined/GuitarOutlined.es.js';
import '../../assets/icons/generated/outlined/HandOutlined.es.js';
import '../../assets/icons/generated/outlined/HeadphonesAddOutlined.es.js';
import '../../assets/icons/generated/outlined/HeadphonesCheckedOutlined.es.js';
import '../../assets/icons/generated/outlined/HeadphonesOutlined.es.js';
import '../../assets/icons/generated/outlined/HeartOutlined.es.js';
import '../../assets/icons/generated/outlined/HelpOutlined.es.js';
import '../../assets/icons/generated/outlined/HideOutlined.es.js';
import '../../assets/icons/generated/outlined/ImageOutlined.es.js';
import '../../assets/icons/generated/outlined/InfoOutlined.es.js';
import '../../assets/icons/generated/outlined/KeyboardOutlined.es.js';
import '../../assets/icons/generated/outlined/LeaveOutlined.es.js';
import '../../assets/icons/generated/outlined/ListOutlined.es.js';
import '../../assets/icons/generated/outlined/ListUnorderedOutlined.es.js';
import '../../assets/icons/generated/outlined/ListMusicNoteOutlined.es.js';
import '../../assets/icons/generated/outlined/LockOutlined.es.js';
import '../../assets/icons/generated/outlined/LogoOutlined.es.js';
import '../../assets/icons/generated/outlined/LoopOutlined.es.js';
import '../../assets/icons/generated/outlined/MagicWandOutlined.es.js';
import '../../assets/icons/generated/outlined/MailOutlined.es.js';
import '../../assets/icons/generated/outlined/MenuInvertedOutlined.es.js';
import '../../assets/icons/generated/outlined/MenuOutlined.es.js';
import '../../assets/icons/generated/outlined/MicrophoneOffOutlined.es.js';
import '../../assets/icons/generated/outlined/MicrophoneOutlined.es.js';
import '../../assets/icons/generated/outlined/MinimizeOutlined.es.js';
import '../../assets/icons/generated/outlined/MinusOutlined.es.js';
import '../../assets/icons/generated/outlined/MoneyOutlined.es.js';
import '../../assets/icons/generated/outlined/MonitorOffOutlined.es.js';
import '../../assets/icons/generated/outlined/MonitorOutlined.es.js';
import '../../assets/icons/generated/outlined/MoveToFolderOutlined.es.js';
import '../../assets/icons/generated/outlined/MusicNoteOff.es.js';
import '../../assets/icons/generated/outlined/MusicNote.es.js';
import '../../assets/icons/generated/outlined/NetworkOutlined.es.js';
import '../../assets/icons/generated/outlined/NoteOutlined.es.js';
import '../../assets/icons/generated/outlined/OrderOutlined.es.js';
import '../../assets/icons/generated/outlined/PackOutlined.es.js';
import '../../assets/icons/generated/outlined/PaperPlaneOutlined.es.js';
import '../../assets/icons/generated/outlined/PencilOutlined.es.js';
import '../../assets/icons/generated/outlined/PencilPaperOutlined.es.js';
import '../../assets/icons/generated/outlined/PercentageOutlined.es.js';
import '../../assets/icons/generated/outlined/PhoneOutlined.es.js';
import '../../assets/icons/generated/outlined/PianoOutlined.es.js';
import '../../assets/icons/generated/outlined/PlaylistOutlined.es.js';
import '../../assets/icons/generated/outlined/PlusOutlined.es.js';
import '../../assets/icons/generated/outlined/PreserverOutlined.es.js';
import '../../assets/icons/generated/outlined/PriceTagOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductBlogOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductNetworkOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductPluginsOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductProjectsOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductReleasesOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductSamplesOutlined.es.js';
import '../../assets/icons/generated/outlined/ProfileOutlined.es.js';
import '../../assets/icons/generated/outlined/ProviderOutlined.es.js';
import '../../assets/icons/generated/outlined/QuoteOutlined.es.js';
import '../../assets/icons/generated/outlined/RemoveOutlined.es.js';
import '../../assets/icons/generated/outlined/RepeatOutlined.es.js';
import '../../assets/icons/generated/outlined/ReplaceOutlined.es.js';
import '../../assets/icons/generated/outlined/ReplyOutlined.es.js';
import '../../assets/icons/generated/outlined/SearchOutlined.es.js';
import '../../assets/icons/generated/outlined/SendFileToOutlined.es.js';
import '../../assets/icons/generated/outlined/SharingOutlined.es.js';
import '../../assets/icons/generated/outlined/ShowOutlined.es.js';
import '../../assets/icons/generated/outlined/SidebarOutlined.es.js';
import '../../assets/icons/generated/outlined/SliderOutlined.es.js';
import '../../assets/icons/generated/outlined/SoundOutlined.es.js';
import '../../assets/icons/generated/outlined/StarOutlined.es.js';
import '../../assets/icons/generated/outlined/SuccessOutlined.es.js';
import '../../assets/icons/generated/outlined/SunOutlined.es.js';
import '../../assets/icons/generated/outlined/TiktokOutlined.es.js';
import '../../assets/icons/generated/outlined/TrashOutlined.es.js';
import '../../assets/icons/generated/outlined/TrendingUpOutlined.es.js';
import '../../assets/icons/generated/outlined/UpDownOutlined.es.js';
import '../../assets/icons/generated/outlined/UploadOutlined.es.js';
import '../../assets/icons/generated/outlined/UserMessageOutlined.es.js';
import '../../assets/icons/generated/outlined/UserOutlined.es.js';
import '../../assets/icons/generated/outlined/UserPlusOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoChatOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoOffOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoOnOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoRecordingOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoSquareOutlined.es.js';
import '../../assets/icons/generated/outlined/WarningOutlined.es.js';
import '../../assets/icons/generated/products/Blog.es.js';
import '../../assets/icons/generated/products/ChromaticDark.es.js';
import '../../assets/icons/generated/products/Chromatic.es.js';
import '../../assets/icons/generated/products/CommunityChannels.es.js';
import '../../assets/icons/generated/products/Courses.es.js';
import '../../assets/icons/generated/products/Creator.es.js';
import '../../assets/icons/generated/products/Distribution.es.js';
import '../../assets/icons/generated/products/Insider.es.js';
import '../../assets/icons/generated/products/LandrFx.es.js';
import '../../assets/icons/generated/products/Mastering.es.js';
import '../../assets/icons/generated/products/NetworkPro.es.js';
import '../../assets/icons/generated/products/NetworkServices.es.js';
import '../../assets/icons/generated/products/Network.es.js';
import '../../assets/icons/generated/products/Plugins.es.js';
import '../../assets/icons/generated/products/ProjectsBlue.es.js';
import '../../assets/icons/generated/products/ProjectsRed.es.js';
import '../../assets/icons/generated/products/SamplesDark.es.js';
import '../../assets/icons/generated/products/Samples.es.js';
import '../../assets/icons/generated/products/SessionsDark.es.js';
import '../../assets/icons/generated/products/Sessions.es.js';
import '../../assets/icons/generated/products/Tutorials.es.js';
import '../../assets/icons/generated/products/Vocalign.es.js';
import '../../primitives/Box/Box.es.js';
import '../../primitives/Center/styled.es.js';
import { Group } from '../../primitives/Group/Group.es.js';
import '../../primitives/Grid/Grid.es.js';
import '../../primitives/Level/Level.es.js';
import '../../primitives/Shelf/Shelf.es.js';
import '../../primitives/Portal/Portal.es.js';
import '../../primitives/Hidden/Hidden.es.js';
import '../../primitives/Media/Media.es.js';
import '../../primitives/Dialog/Dialog.es.js';
import '../../primitives/VisuallyHidden/VisuallyHidden.es.js';
import '../../primitives/TruncateByCharacters/TruncateByCharacters.es.js';
import '../../primitives/TruncateByLines/TruncateByLines.es.js';
import 'react-transition-group';
import '../../primitives/Popper/Popper.es.js';
import '../../primitives/DragHandle/DragHandle.es.js';
import '../../primitives/Pin/Pin.es.js';
import '../MaestroThemeProvider/MaestroThemeProvider.es.js';
import { ColorMode } from '../MaestroThemeProvider/ColorMode.es.js';
import '../GlobalStyle/GlobalStyle.es.js';
import { Text } from '../Text/Text.es.js';
import '../Heading/Heading.es.js';
import '../Paragraph/Paragraph.es.js';
import '../Badge/styled.es.js';
import '../Card/Card.es.js';
import '../AppLayout/AppLayout.es.js';
import '../Container/Container.es.js';
import '../Container/NegativeWrapper.es.js';
import '../Overlay/Overlay.es.js';
import '../Avatar/Avatar.es.js';
import '../Checkbox/Checkbox.es.js';
import '../Radio/Radio.es.js';
import '../Radio/RadioPrimitive/RadioPrimitive.es.js';
import '../Radio/RadioGroup/RadioGroup.es.js';
import '../Radio/RadioCard/RadioCard.es.js';
import '../DropdownMenu/DropdownMenu.es.js';
import '../Switch/Switch.es.js';
import '../Image/Image.es.js';
import '../Drawer/Drawer.es.js';
import '../UiState/UiState.es.js';
import '../Input/Input.es.js';
import '../ChipInput/ChipInput.es.js';
import '../Notification/Notification.es.js';
import '../Notification/styled.es.js';
import '../Pagination/Pagination.es.js';
import '../Table/Table.es.js';
import '../Table/TableContext.es.js';
import '../PopoverBase/PopoverBase.es.js';
import '../Popover/Popover.es.js';
import '../Popover/PopoverContext.es.js';
import '../Tooltip/Tooltip.es.js';
import '../Message/Message.es.js';
import '../Modal/Modal.es.js';
import '../NavBar/NavBar.es.js';
import '../NavBar/context.es.js';
import '../Banner/Banner.es.js';
import '../FloatingActionMenu/FloatingActionMenu.es.js';
import '../FeatureCard/FeatureCard.es.js';
import '../Logo/Logo.es.js';
import '../Carousel/Carousel.es.js';
import '../Divider/Divider.es.js';
import '../SiteLayout/SiteLayout.es.js';
import '../PeopleCard/PeopleCard.es.js';
import '../StarRating/StarRating.es.js';
import '../Skeleton/Skeleton.es.js';
import '../Indicator/Indicator.es.js';
import '../FormControl/FormControl.es.js';
import '../FormControl/FormControlContext.es.js';
import '../InputGroup/InputGroup.es.js';
import '../Textarea/Textarea.es.js';
import '../Select/Select.es.js';
import '../Select/SelectNative.es.js';
import '../Dropzone/Dropzone.es.js';
import '../Collapse/Collapse.es.js';
import '../Collapse/Accordion.es.js';
import '../Link/Link.es.js';
import '../Chip/Chip.es.js';
import '../ChipGroup/ChipGroup.es.js';
import '../Calendar/Calendar.es.js';
import { DismissButton } from '../DismissButton/DismissButton.es.js';
import '../AssetCard/AssetCard.es.js';
import '../AssetCardGroup/AssetCardGroup.es.js';
import '../Autocomplete/Autocomplete.es.js';
import '../List/List.es.js';
import '../Progress/Progress.es.js';
import '../AvatarGroup/AvatarGroup.es.js';
import '../Scrollable/Scrollable.es.js';
import '../Nav/Nav.es.js';
import '../ToggleButton/ToggleButton.es.js';
import '../ToggleButton/ToggleButtonGroup.es.js';
import '../IconButton/IconButton.es.js';
import '../Breadcrumb/Breadcrumb.es.js';
import '../ProductHeader/ProductHeader.es.js';
import '../RichTimestamp/RichTimestamp.es.js';
import '../Autocomplete/experimental/ComboBox/ComboBox.es.js';
import '../Autocomplete/experimental/MultiSelect/MultiSelect.es.js';
import '../Flex/Flex.es.js';
import '../Alert/Alert.es.js';
import '../FilterDropdown/FilterDropdown.es.js';
import '../AspectRatio/AspectRatio.es.js';
import '../SearchInput/SearchInput.es.js';
import '../Stack/Stack.es.js';
import '../Truncate/Truncate.es.js';
import '../Tabs/Tabs.es.js';
import '../Tiles/Tiles.es.js';
import '../Slider/Slider.es.js';
import '../LegacyFilters/Filters.es.js';
import '../LegacyFilters/styled/Filters.es.js';
import '../LegacyFilters/styled/Filter.es.js';
import '../LegacyFilters/styled/ListFilter.es.js';
import '../LegacyFilters/styled/SelectedFilters.es.js';
import '../LegacyFilters/ListFilter.es.js';
import '../../themes/defaultTheme.es.js';
import { Wrapper } from './styled.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
function notificationBarIcon(variant, icon) {
  if (typeof icon !== "undefined" && !icon) {
    return false;
  }
  if (typeof icon === "undefined") {
    switch (variant) {
      case "informational":
        return () => /* @__PURE__ */ React.createElement(InfoFilled, null);
      case "success":
        return () => /* @__PURE__ */ React.createElement(CheckCircleFilled, null);
      case "warning":
        return () => /* @__PURE__ */ React.createElement(WarningFilled, null);
      case "error":
        return () => /* @__PURE__ */ React.createElement(WarningFilled, null);
      default:
        return false;
    }
  }
  return icon;
}
function notificationBarActionProps(variant) {
  let defaultProps = { size: "sm" };
  switch (variant) {
    case "informational":
    case "error":
      defaultProps = __spreadProps(__spreadValues({}, defaultProps), { variant: "subtle" });
      break;
    case "success":
    case "warning":
      defaultProps = __spreadProps(__spreadValues({}, defaultProps), { variant: "secondary" });
      break;
  }
  return defaultProps;
}
const getNotificationBarDismissButtonVariant = (variant) => {
  switch (variant) {
    case "informational":
      return "accent";
    case "success":
      return "primary";
    case "warning":
      return "warning";
    case "error":
      return "danger";
    default:
      return;
  }
};
const NotificationBarComponent = ({
  children,
  variant,
  icon,
  action,
  onDismiss,
  dismissLabel = "Dismiss"
}) => {
  const Icon = notificationBarIcon(variant, icon);
  const defaultActionProps = notificationBarActionProps(variant);
  const dismissVariant = getNotificationBarDismissButtonVariant(variant);
  const isMobile = useBreakpoint("sm");
  const gutter = isMobile ? "xs" : "md";
  const handleDismiss = () => {
    onDismiss == null ? void 0 : onDismiss();
  };
  return /* @__PURE__ */ React.createElement(Wrapper, {
    p: "md",
    variant
  }, /* @__PURE__ */ React.createElement(Group, {
    sx: { ml: isMobile ? 0 : onDismiss ? "auto" : 0 },
    direction: "horizontal",
    alignItems: isMobile ? !action && !onDismiss ? "center" : "flex-start" : "center",
    gutter
  }, Icon && /* @__PURE__ */ React.createElement(Group.Item, {
    display: "flex"
  }, /* @__PURE__ */ React.createElement(Icon, null)), /* @__PURE__ */ React.createElement(Group.Item, null, /* @__PURE__ */ React.createElement(Group, {
    direction: isMobile ? "vertical" : "horizontal",
    alignItems: isMobile ? "stretch" : "center",
    justifyContent: "center",
    gutter: !action && !onDismiss ? "none" : gutter
  }, /* @__PURE__ */ React.createElement(Group.Item, null, /* @__PURE__ */ React.createElement(Text, null, children)), /* @__PURE__ */ React.createElement(Group.Item, null, /* @__PURE__ */ React.createElement(Group, {
    gutter: "xs"
  }, action && /* @__PURE__ */ React.createElement(Group.Item, null, /* @__PURE__ */ React.createElement(ColorMode, {
    mode: "light"
  }, /* @__PURE__ */ React.createElement(Button, __spreadValues(__spreadValues({
    isRounded: true
  }, defaultActionProps), action)))), isMobile && !!onDismiss && /* @__PURE__ */ React.createElement(Group.Item, null, /* @__PURE__ */ React.createElement(Button, {
    size: "sm",
    onClick: handleDismiss,
    variant: dismissVariant,
    isRounded: true
  }, dismissLabel))))))), !isMobile && !!onDismiss && /* @__PURE__ */ React.createElement(DismissButton, {
    sx: { ml: "auto", alignSelf: "center" },
    size: "sm",
    onClick: handleDismiss,
    variant: dismissVariant,
    isRounded: true
  }));
};
const NotificationBar = maestroComponent("NotificationBar", NotificationBarComponent);

export { NotificationBar };
//# sourceMappingURL=NotificationBar.es.js.map
